import gsap from "gsap";
import { Value } from "./core/Value";
import _CURRENCY from "./data/currency.json";
import DynamicValue from "./DynamicValue";
const CURRENCY = _CURRENCY as Record<string, string>
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export default class Common
{


    static getVideoUrl()
    {
        const baseUrl = "https://promo.spribegame.com/aviator/assets/video/how-to-play"
        const vids = ["bg", "fa", "hr", "it", "ko", "ro", "ru", "tr"];
        if (vids.indexOf(params.language) !== -1)
        {
            return baseUrl + "-" + params.language + ".mp4";
        }
        return baseUrl + "-en.mp4";
    }


    static getMultiplierIndex(multiplier?: number | string)
    {
        multiplier = Number(multiplier);

        if (multiplier >= 10)
        {
            return 2;
        }
        else if (multiplier >= 2)
        {
            return 1;
        }
        else 
        {
            return 0;
        }
    }


    static parseMultiplierClassName(multiplier?: number | string)
    {
        switch (this.getMultiplierIndex(multiplier))
        {
            case 0: return " low ";
            case 1: return " medium ";
            case 2: return " high ";
            default: return " low ";
        }
    }


    static renderMultiplier(multiplier?: number | string, none: string = "")
    {
        let val;
        let className = "payout ";

        multiplier = Number(multiplier);

        if (!multiplier)
        {
            val = none;
        }
        else 
        {
            val = Common.formatCurrency(multiplier.toFixed(2)) + "x"
            className += this.parseMultiplierClassName(multiplier);
        }

        return (
            <div className={className}>
                {val}
            </div>
        );
    }


    static formatCurrency(value: number | string, ignoreDecimals?: boolean)
    {
        if (!ignoreDecimals)
        {
            value = Number(value).toFixed(2);
        }

        let [base, decimals] = value.toString().split(".");
        for (let i = 1; i * 3 < base.length + 1 - i; i++)
        {
            base = base.slice(0, base.length - i * 3 - (i - 1)) + "," + base.slice(base.length - i * 3 - (i - 1));
        }

        return [base, decimals].filter(v => v?.length).join(".");
    }


    static renderCurrency(value?: string | number | ValueId, currency?: string, none: string = "", decimals?: number, ignoreDecimals?: boolean)
    {
        if (isNaN(Number(value)) || Number(value) > 0)
        {
            return (
                <div className="money">
                    <div>
                        {this.renderValue(value, decimals)}
                    </div>
                </div>
            );
        }
        else
        {
            return (
                <div>
                    {none}
                </div>
            );
        }
    }


    static renderValue(value: string | number | ValueId, decimals?: number)
    {
        if (!isNaN(Number(value)))
        {
            return this.formatCurrency(Number(value).toFixed(decimals != null ? decimals : 2));
        }
        else
        {
            return (
                <DynamicValue
                    id={value as string}
                />
            )
        }
    }


    static parseCurrency(currency?: string)
    {
        if (currency)
        {
            return CURRENCY[currency] || currency;
        }

        return "";
    }


    static prefix(value: string, length: number, char: string)
    {
        while (value.length < length)
        {
            value = char + value;
        }

        return value;
    }


    /**
     * 
     * @param date 
     * @param type 
     * @example
     *  type -       time: 14:05
     *  type -  time_full: 14:05:22
     *  type -       date: 27 JAN
     *  type -  date_full: 27 JAN 14:05:22
     *  type - date_small: 27-01-22
     *  type -  timestamp: 2022-01-22 14:05:22
     * @returns 
     */
    static parseDate(timestamp: string | Date, type: "time" | "time_full" | "date" | "date_full" | "date_small" | "timestamp" = "time", isGmt0: boolean = false)
    {
        let date;
        if (typeof timestamp == "string")
        {
            const s = timestamp.split(/[- :]/).map(s => Number(s));
            date = new Date(s[0], s[1] - 1, s[2], s[3], s[4], s[5]);
        }
        else
        {
            date = timestamp;
        }

        if (isGmt0)
        {
            date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
        }

        const locale = window.lang.shared.date;
        const month: string = MONTHS[date.getMonth()];
        // const localeMonth = locale.month["Jan"]
        const localeMonth = locale.month[month as keyof typeof locale.month];
        // { data["how-to-play"] }

        switch (type)
        {
            case "time":
                return this.prefix(date.getHours().toString(), 2, "0") + ":" +
                    this.prefix(date.getMinutes().toString(), 2, "0");

            case "time_full":
                return this.prefix(date.getHours().toString(), 2, "0") + ":" +
                    this.prefix(date.getMinutes().toString(), 2, "0") + ":" +
                    this.prefix(date.getSeconds().toString(), 2, "0");

            case "date":
                return this.prefix(date.getDate().toString(), 2, "0",) + " " +
                    localeMonth;

            case "date_full":
                return this.prefix(date.getDate().toString(), 2, "0",) + " " +
                    localeMonth + " " +
                    this.prefix(date.getHours().toString(), 2, "0") + ":" +
                    this.prefix(date.getMinutes().toString(), 2, "0") + ":" +
                    this.prefix(date.getSeconds().toString(), 2, "0");

            case "date_small":
                return this.prefix(date.getDate().toString(), 2, "0",) + "-" +
                    this.prefix((date.getMonth() + 1).toString(), 2, "0",) + "-" +
                    date.getFullYear().toString().substring(2);

            case "timestamp":
                return date.getFullYear().toString() + "-" +
                    this.prefix((date.getMonth() + 1).toString(), 2, "0") + "-" +
                    this.prefix(date.getDate().toString(), 2, "0") + " " +
                    this.prefix(date.getHours().toString(), 2, "0") + ":" +
                    this.prefix(date.getMinutes().toString(), 2, "0") + ":" +
                    this.prefix(date.getSeconds().toString(), 2, "0");

        }
    }


    static getTimestamp()
    {
        const date = new Date();
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        return this.parseDate(date, "timestamp");
    }


    static replaceTextValue(text: string, replace: Record<any, string>)
    {
        let str = "";
        let idx = 0;
        const regex = /\{\{(.+?)\}\}/g;
        let match = regex.exec(text);
        while (match)
        {
            str += text.substring(idx, match.index);
            idx = match.index + match[0].length;
            str += replace[match[1]];

            match = regex.exec(text);
        }

        str += text.substring(idx);
        return str;
    }


    static recursiveUpdateTweens(tweens: Array<GSAPTween | GSAPTimeline>)
    {
        tweens.sort((a, b) => (a.startTime() + a.duration()) - (b.startTime() + b.duration()));

        while (tweens.length > 0)
        {
            const tween = tweens.shift();
            
            const duration = tween.duration();
            const startTime = tween.startTime();
            
            let ratio = -1;
            const time = gsap.ticker.time - startTime;
            if (time >= 0)
            {
                if (duration > 0)
                {
                    ratio = time / duration;
                }
                else
                {
                    ratio = 1;
                }
            }

            const tweens1 = gsap.globalTimeline.getChildren();
            if (ratio >= 0)
            {
                if (ratio >= 1)
                {
                    tween.progress(1);
                    tween.kill();
                }
                else
                {
                    tween.progress(ratio);
                }
            
            }
            const tweens2 = gsap.globalTimeline.getChildren();

            if (ratio >= 1)
            {
                for (let i = 0; i < tweens1.length; i++)
                {
                    const idx = tweens2.indexOf(tweens1[i]);
                    if (idx !== -1)
                    {
                        tweens2.splice(idx, 1);
                    }
                }
                
                for (let i = 0; i < tweens2.length; i++)
                {
                    const overflow = gsap.ticker.time - startTime - duration;
                    tweens2[i].startTime(tweens2[i].startTime() - overflow);
                    tweens.push(tweens2[i]);
                }

                if (tweens.length > 0)
                {
                    tweens.sort((a, b) => (a.startTime() + a.duration()) - (b.startTime() + b.duration()));
                }
            }
        }
    }


}

// @ts-ignore
window.Common = Common;